import { SectionNav } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';

export const FINANCE_SECTIONS = ['overview', 'remittances', 'disputes', 'expenses'] as const;
export type FinanceSection = (typeof FINANCE_SECTIONS)[number];

export type FinanceSectionsProps = { current: FinanceSection; onSelect: (section: FinanceSection) => void };

export const FinanceSections = ({ current, onSelect }: FinanceSectionsProps) => {
  const { t } = usePageContext();
  return (
    <SectionNav
      label={t('finance.sections')}
      current={current}
      sections={FINANCE_SECTIONS.map((section) => ({ id: section, label: t(`finance.section_${section}`) }))}
      onSelect={onSelect}
    />
  );
};
